import { render, staticRenderFns } from "./ProductListComponent.vue?vue&type=template&id=771727c4&scoped=true&"
import script from "./ProductListComponent.vue?vue&type=script&lang=ts&"
export * from "./ProductListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ProductListComponent.vue?vue&type=style&index=0&id=771727c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771727c4",
  null
  
)

export default component.exports